import { Component, OnInit, Injector } from '@angular/core';
import { FileUploadService } from './file-upload.service';

@Component({
  selector: 'work-order-file-upload',
  templateUrl: './work-order-file-upload.component.html',
  styleUrls: ['./work-order-file-upload.component.scss']
})
export class WorkOrderFileUploadComponent implements OnInit {
  fileUploadService: FileUploadService;

  constructor(injector: Injector) {
    this.fileUploadService = injector.get(FileUploadService);
  }

  ngOnInit() {
    //this is kept empty on purpose
  }
}
